import React, { useState, useEffect } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import tw, { css } from 'twin.macro'
import { X, Check, ChevronDown, ChevronUp } from 'react-feather'
import { XIcon, TrashIcon } from '@heroicons/react/solid';
export const CompareModal = ({selectedProducts, products, id, style,setShowCompareModal }) =>  {
	const [specOpen, setSpecOpen] = useState(false)
	const [featOpen, setFeatOpen] = useState(false)
	const [warOpen, setWarOpen] = useState(false)
	const [upgOpen, setUpgOpen] = useState(false)
  const selectedProductsData = selectedProducts.map(product => products.find(p => p.name === product)).filter(product => product)
	return (
		<>
     <div className="fixed z-40 inset-0 h-screen w-screen bg-gray-800 bg-opacity-70 overflow-auto p-2">
      <div className='mx-auto max-w-screen-xl bg-white my-10 relative rounded-2xl'>
      <button 
            className="absolute top-1 right-1 bg-red-500 text-white rounded-full text-xs cursor-pointer"
            style={{ transform: 'translate(50%, -50%)' }}
          >
            <XIcon className="h-6 w-6 text-white" style={{padding:'4px'}} onClick={()=>setShowCompareModal(false)}/>
          </button>
			<div className="overflow-scroll lg:overflow-x-hidden px-2 md:px-8">
				<table id={id} css={style}>
					<caption className='uppercase'>Comparison table</caption>
					<thead>
						<tr>
							<th tw="align-bottom text-left md:!text-right" scope="col">
								Maytronics Water <br />
								Treatment Product
							</th>
							{selectedProductsData.map(({ image, name, index }) => {
								return (
								<th scope="col" tw="text-center" key={index} >
									<div>
                    {image?.image ? (image.gatsby ? <GatsbyImage image={image.image} /> : <img className='h-full object-contain object-center w-full' src={image.image} alt={`${name}`} style={{maxHeight:"250px"}}/>) : <div style={{minHeight:"120px"}} aria-hidden />}					
                   
									</div>
									<p>{name}</p>
								</th>
							)})}
						</tr>
					</thead>
					<tbody>
						<tr>
							<td
								tw="font-semibold"
								scope="row"
								data-label="Maytronics Water Treatment Product"
							>
								PRODUCT CODE
							</td>
              {selectedProductsData.map(({ productCode, index }) => {
                return (<td key={index} >{productCode}</td>)
              })}
						</tr>
						<tr>
							<td
								tw="font-semibold"
								scope="row"
								data-label="Maytronics Water Treatment Product"
							>
								RRP
							</td>
              {selectedProductsData.map(({ price, index }) => {
                return (<td key={index} >{price}</td>)
              })}
						</tr>
						<tr
							tw="cursor-pointer"
							onClick={() => setSpecOpen((prevState) => !prevState)}
							className="trow-title"
						>
							<td
								tw="cursor-pointer font-medium bg-white py-4 uppercase text-lg border-t-2 border-b-2 border-t-gray-400 border-b-gray-400"
								scope="row"
							>
								Specifications
								{specOpen ? (
									<ChevronUp tw="inline-block ml-2 self-center" />
								) : (
									<ChevronDown tw="inline-block ml-2 self-center" />
								)}
							</td>
							<td tw="md:bg-white" colSpan={`${selectedProductsData.length}`} />
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Recommended Max Poolsize
							</td>
              {selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.recommendedMaxPoolSize}</td>)
              })}
												</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Nominal Chlorine Output
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.nominalChlorineOutput}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Ozone Purification
							</td>
              {selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.ozonePurification ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Mineral/Salt Chlorinator
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.chlorinator ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Modular system with Future Module Upgrades Available
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.futureModularSystemUpgrade ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Hand-Held Controller
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.handHeldController ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Generator Module
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.generatorModule ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Purifier Module 
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.purifierModule ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Additional Chlorinator Required
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.additionalChlorinator ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Compatible with Mineral Swim&trade; Dead Sea Minerals
							</td>
							{selectedProductsData.map(({ specifications , index}) => {
                return (<td key={index} >{specifications.deadSeaMineralCompatible ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Operating Modes
							</td>
							{selectedProductsData.map(({ specifications, index}) => {
                return (<td key={index} >{specifications.operatingModes}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Operating TDS Level
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.tdsLevel}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Installation Time
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.installationTime}</td>)
              })}
						</tr>
						{/* <tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Professional Pool Side Health Checks
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.poolsideHealthChecks}</td>)
              })}
						</tr> */}
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Mineral Swim&trade; Welcome Pack
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.welcomePack ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Ecoclear&reg; Shield & Swim, 3 in 1 Pool Water Optimiser
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.poolWaterOptimizer ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Made in Australia
							</td>
							{selectedProductsData.map(({ specifications, index }) => {
                return (<td key={index} >{specifications.australia ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr
							tw="cursor-pointer"
							onClick={() => setFeatOpen((prevState) => !prevState)}
							className="trow-title"
						>
							<td
								tw="cursor-pointer font-medium bg-white py-4 uppercase text-lg border-t-2 border-b-2 border-t-gray-400 border-b-gray-400"
								scope="row"
							>
								Features
								{featOpen ? (
									<ChevronUp tw="inline-block ml-2 self-center" />
								) : (
									<ChevronDown tw="inline-block ml-2 self-center" />
								)}
							</td>
							<td tw="md:bg-white" colSpan={`${selectedProductsData.length}`} />
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Dual Chlorine & Ozone Sanitation
							</td>
              {selectedProductsData.map(({ features, index }) => {
                return (<td key={index} >{features.dualSanitaion ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Healthy Pool Water Purification
							</td>
							{selectedProductsData.map(({ features, index }) => {
                return (<td key={index} >{features.poolWaterPurification ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Allergy, Asthma & Eczema Friendly
							</td>
              {selectedProductsData.map(({ features, index }) => {
                return (<td key={index} >{features.allergyFriendly ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Reduced Chlorine & Chemical Usage
							</td>
							{selectedProductsData.map(({ features, index }) => {
                return (<td key={index} >{features.reducedChemicals ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Chloramine Removal
							</td>
              {selectedProductsData.map(({ features, index }) => {
                return (<td key={index} >{features.chloramineRemoval ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Safe Sanitation By-Products
							</td>
							{selectedProductsData.map(({ features, index }) => {
                return (<td key={index} >{features.safeSanitation ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Reduced Eye Irritation
							</td>
							{selectedProductsData.map(({ features,index }) => {
                return (<td key={index} >{features.reducedEyeIritation ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>

						<tr
							tw="cursor-pointer"
							onClick={() => setWarOpen((prevState) => !prevState)}
							className="trow-title"
						>
							<td
															tw="cursor-pointer font-medium bg-white py-4 uppercase text-lg border-t-2 border-b-2 border-t-gray-400 border-b-gray-400 flex justify-end"
															scope="row"
															onClick={() => setWarOpen((prevState) => !prevState)}
														>
															<div>
															<p>Warranty</p>
															<p tw='text-xs normal-case text-gray-700' >For full T&Cs refer to the manual</p>
															</div>
															{warOpen ? (
																<ChevronUp tw="inline-block ml-2 self-center" />
															) : (
																<ChevronDown tw="inline-block ml-2 self-center" />
															)}
														</td>
							<td tw="md:bg-white" colSpan={`${selectedProductsData.length}`} />
						</tr>
						<tr css={[!warOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								System (control box, electronics, seals)
							</td>
							{selectedProductsData.map(({ warranty,index }) => {
                return (<td key={index} >{warranty.system}</td>)
              })}
						</tr>
						<tr css={[!warOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Ozone Cell
							</td>
							{selectedProductsData.map(({ warranty,index }) => {
                return (<td key={index} >{warranty.ozoneCell}</td>)
              })}
						</tr>
						<tr css={[!warOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Electrolyic Cell
							</td>
							{selectedProductsData.map(({ warranty, index }) => {
                return (<td key={index} >{warranty.electrolyicCell}</td>)
              })}
						</tr>

						<tr
							tw="cursor-pointer"
							onClick={() => setUpgOpen((prevState) => !prevState)}
							className="trow-title"
						>
							<td
								tw="cursor-pointer font-medium bg-white py-4 uppercase text-lg border-t-2 border-b-2 border-t-gray-400 border-b-gray-400"
								scope="row"
							>
								Upgrades
								{upgOpen ? (
									<ChevronUp tw="inline-block ml-2 self-center" />
								) : (
									<ChevronDown tw="inline-block ml-2 self-center" />
								)}
							</td>
							<td tw="md:bg-white" colSpan={`${selectedProductsData.length}`} />
						</tr>
						<tr css={[!upgOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								pH Drive Series
							</td>
              {selectedProductsData.map(({ upgrades, index }) => {
                return (<td key={index} >{upgrades.phDrive ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!upgOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Mineral Swim&trade; 100% Dead Sea Minerals
							</td>
              {selectedProductsData.map(({ upgrades,index }) => {
                return (<td key={index} >{upgrades.mineralSwim ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr css={[!upgOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Upgrade to Ozone Purification Available 
							</td>
							{selectedProductsData.map(({ upgrades, index }) => {
                return (<td key={index} >{upgrades.ozoneUpgradable ? <Check tw="mx-auto md:mx-auto" /> : <X tw="mx-auto md:mx-auto" />}</td>)
              })}
						</tr>
						<tr>
							<td >							
							</td>
              {selectedProductsData.map(({ unavailable,url,index }) => {
                return (<td key={index} ><a href={`${url}`} target='_blank' rel='noopener noreferrer'><button className='font-semibold whitespace-nowrap inline-flex items-center justify-center px-4 py-1 border border-transparent rounded shadow-sm bg-blue-500 hover:bg-blue-400 text-white hover:text-gray-800'>{unavailable ?"ENQUIRE NOW" :"BUY NOW"}</button></a></td>)
              })}
						</tr>
					</tbody>
				</table>
			</div>
      </div>
      </div>
		</>
	)
}